
import {validator, deny} from "@e280/stz"
import {consts} from "../../../../consts.js"

export const validateAlias = validator<string>(
	deny("bad leading or trailing whitespace", s => s !== s.trim()),
	deny("too small", s => s.length < 1),
	deny("too big", s => s.length > consts.maxAliasLength),
	deny("bad consecutive spaces", s => /[ ]{2,}/u.test(s)),
	deny("bad weird whitespace", s => /\s/.test(s.replaceAll(" ", ""))),
	deny("bad unicode control chars", s => /\p{Z}\p{C}/u.test(s.replaceAll(" ", ""))),
)

